class SplashLogo {
  constructor() {
    this.$splashLogo = document.querySelector("[data-splash-logo]");
    this.$timer = document.querySelector("[data-splash-logo-timer]");
    this.$uiElements = document.querySelectorAll("[data-splash-logo-ui]");
    if (this.$splashLogo && this.$timer) {
      this.setup();
    }
  }

  setSplashAsLoaded() {
    this.$splashLogo.classList.add("c-splash-logo--loaded");
  }
  setup() {
    if (this.isUniqueVisitor()) {
      this.storeUniqueVisitor();
      this.setSplashAsLoaded();
      this.startTimer();
    } else {
      this.remove();
    }
  }

  isUniqueVisitor(force) {
    if (force) {
      return true;
    }
    return localStorage.getItem("noUniqueVisitor") === null;
  }

  storeUniqueVisitor() {
    localStorage.setItem("noUniqueVisitor", "true");
  }

  startTimer() {
    this.$timer.classList.add("c-splash-logo__timer--go");
    this.$timer.addEventListener("transitionend", () => {
      this.transition();
    });
  }

  transition() {
    this.$splashLogo.classList.add("c-splash-logo--fade-out");
    this.$uiElements.forEach(($uiElement) => {
      $uiElement.classList.remove("c-splash-logo-ui--fade-in");
      $uiElement.classList.remove("c-splash-logo-ui--in-from-top");
    });
    requestAnimationFrame(() => {
      this.$splashLogo.addEventListener("transitionend", () => {
        this.remove();
      });
    });
  }

  remove() {
    this.$splashLogo.remove();
  }
}

export default new SplashLogo();
